import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";
import { useTranslation } from "common/locales";
import useConfirmation from "common/utils/useConfirmation";
import { AnimalGroup, useDeleteAnimalGroup } from "model";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "stores";
import { AnalyticsEvents, analytics } from "../../common/analytics";

export default function AnimalGroupDeleteButton({ guid, name }: AnimalGroup) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentFarmId = useAppStore((state) => state.currentFarmId);
  const deleteAnimalGroupMutation = useDeleteAnimalGroup();

  const confirmDeleteGroup = useConfirmation({
    title: t("confirmationdeletedialog.animalGroup.title"),
    description: t("confirmationdeletedialog.animalGroup.description", {
      name,
    }),
  });

  async function deleteGroup() {
    const confirmed = await confirmDeleteGroup();
    if (!confirmed) return;
    await deleteAnimalGroupMutation.mutateAsync(guid);
    analytics.track(AnalyticsEvents.ANIMAL_GROUP_DELETED);
    navigate(`/farm/${currentFarmId || ""}`);
  }

  return (
    <IconButton
      edge="end"
      onClick={deleteGroup}
      size="small"
      aria-label={t("animalGroup.menu.delete")}
      sx={{
        backgroundColor: "#FBEAEA",
        color: "#DC2626",
        "&:hover": { backgroundColor: "#F6D5D5" },
      }}
    >
      <DeleteOutlineIcon />
    </IconButton>
  );
}
